import { useNavigate } from "react-router-dom";
import { Lock, Calendar, CreditCard } from "lucide-react";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { CALENDLY_DEMO_URL } from "@/lib/constants/urls";
import { SubscriptionTier } from "../../store/Central/types";

export const getFeatureGateDescription = (subscriptionTier: SubscriptionTier | null) => {
	return `Diese Funktion ist nur mit einem aktiven dentLAB-Abonnement
	verfügbar. ${subscriptionTier === "eligible" ? "Starten Sie jetzt Ihre Testversion, um alle Funktionen zu erleben." : "Upgraden Sie Ihr Konto, um diese Funktion zu nutzen."}`;
};

export const FeatureGateButtons: React.FC<{ subscriptionTier: SubscriptionTier | null, handleBookDemo: () => void, handleGoToSubscription: () => void }> = ({ subscriptionTier, handleBookDemo, handleGoToSubscription }) => {
	return (
		<div className="flex flex-col gap-3 mt-4">
			{subscriptionTier === "eligible" ?
				(<Button
					onClick={handleBookDemo}
					className="w-full gap-2"
					aria-label="book-demo-button"
					data-testid="book-demo-button"
				>
					<Calendar className="w-4 h-4" />
					Demo buchen
				</Button>)
				:
				(<Button
					onClick={handleGoToSubscription}
					className="w-full gap-2"
					aria-label="go-to-subscription-button"
					data-testid="go-to-subscription-button"
				>
					<CreditCard className="w-4 h-4" />
					Zum Abonnement
				</Button>)}
		</div>
	)
}

interface FeatureGateModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const FeatureGateModal: React.FC<FeatureGateModalProps> = ({
	open,
	onOpenChange,
}) => {
	const { subscriptionTier } = useCentralStore((state) => ({
		subscriptionTier: state.subscriptionTier,
	}));
	const navigate = useNavigate();

	const handleBookDemo = () => {
		window.open(CALENDLY_DEMO_URL, "_blank");
		onOpenChange(false);
	};

	const handleGoToSubscription = () => {
		navigate("/organisation/administration/abonnement");
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="max-w-md"
				aria-label="feature-gate-modal"
				data-testid="feature-gate-modal"
			>
				<DialogHeader>
					<div className="flex items-center gap-3 mb-2">
						<div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
							<Lock className="w-5 h-5 text-amber-600" />
						</div>
						<DialogTitle className="text-xl">
							Diese Funktion ist Teil der dentLAB-Vollversion
						</DialogTitle>
					</div>
					<DialogDescription className="text-base text-gray-600">
						{getFeatureGateDescription(subscriptionTier)}
					</DialogDescription>
				</DialogHeader>
				<FeatureGateButtons subscriptionTier={subscriptionTier} handleBookDemo={handleBookDemo} handleGoToSubscription={handleGoToSubscription} />
			</DialogContent>
		</Dialog>
	);
};
